import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { ProgressBar, H4, FormGroup, InputGroup, RadioGroup, Radio, NumericInput, Button, Checkbox } from '@blueprintjs/core';
import MaterialTable from 'material-table';
import { TablePagination } from '@material-ui/core';
import { prepDangerouslySetInnerHTMLString, specialSlice } from '../concord/utils';
import { Tooltip2, Classes } from '@blueprintjs/popover2';

class ClusterContexts extends React.PureComponent {

  state = {

   sampleSize : 1000,
   ignoreLemma4SomeCats : true,
   ignoreSomeRels : true,
   cat2IgnoreLemma: null,
   rel2Ignore:null,
   method:"group",
   cutThreshold : 0.2,
   useEmbed:true,
   minGroupSize : 3,
   waitingForCluster:false,
   permalink:null,
   ignoreGouverningRels:true,
  }

  // first arg is the rowData
  openContextWindow = (e) => {
    e.preventDefault();
    
    if (! e.currentTarget.value) { // use e.currentTarget instead of e.target
        return;
    }
    const concordData=this.props.sentId2Concord[e.currentTarget.value];
    if (! concordData) {
        // console.log("concordData vide");
        return;
    }  
    const { results } = this.props;
    
    const docMeta=results.concord.docMeta;
    const lang=results.lang;
    const aligned_language=results.aligned_language;

    const data = {
      sent_id: concordData.sentId,
      collection: docMeta[concordData.docId].collection,
      lang: lang,
      aligned_language:aligned_language
    };

    const endpoint = '/get_result_meta.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((concordDetail) => {
          window.open(concordDetail.permalink,'_blank')
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
     
  };

  runContextClustering = () => {
    const rel2Ignore= this.state.rel2Ignore ? this.state.rel2Ignore: this.props.results.params.rel2Ignore;
    const cat2IgnoreLemma= this.state.cat2IgnoreLemma ? this.state.cat2IgnoreLemma: this.props.results.params.cat2IgnoreLemma;

    const endpoint = '/clusterContexts.ajax.php';
    const data={
        session_id:     this.props.results['session_name'],
        cut_threshold:  this.state.cutThreshold,
        sample_size:    this.state.sampleSize,
        rel2Ignore:     this.state.ignoreSomeRels? rel2Ignore:"",
        cat2IgnoreLemma:this.state.ignoreLemma4SomeCats? cat2IgnoreLemma:"",
        ignoreGouverningRels:this.state.ignoreGouverningRels,
        method :        this.state.method,
        useEmbed :      this.state.useEmbed,
        minGroupSize :  this.state.minGroupSize
    }

    this.setState({ waitingForCluster: true});
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        //console.log("data"+data);
        this.setState({ waitingForCluster: false, clusters: data });
      });
    })
  };


  render() {
      const { t, results,sentId2Concord } = this.props;
      const span=60;
      const formGroupStyle = {
        display: 'flex',
        //justifyContent: 'space-between',
      };
      let table;
      const key={};
      if (this.state.clusters) {
        const tableData=[];
        for (var i in this.state.clusters) {
            key[i]= this.state.clusters[i][0]+":"+(this.state.clusters[i].length-1).toString();
            for (const sentId of this.state.clusters[i]) {
                const concord=sentId2Concord[sentId];
                if (concord) {
                    concord.clustId=i;
                    tableData.push(concord);
                } else {
                    if (sentId!==this.state.clusters[i][0]) {
                      console.log("Non trouvé SentId="+sentId)
                    }
                }
            }
        }  
        table=<MaterialTable
            title={t('conc')}
            
            columns={[
                {   
                    title: t('ID'), 
                    field: 'clustId', 
                    render: rowData => <Tooltip2 minimal={false} intent="primary" className={Classes.TOOLTIP2_INDICATOR} content={key[rowData.clustId]}>{rowData.clustId}</Tooltip2>,
                    width: '5%',
                    cellStyle: {
                        textAlign:'center',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center',
                        padding:'0'
                    }
                }, 
                {   
                    title: t('context'), 
                    width: '5%',
                    render: rowData => <Button onClick={this.openContextWindow} value={rowData.sentId} icon='info-sign'></Button>,
                    cellStyle: {
                        textAlign:'center',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center',
                        padding:'0'
                    }
                },
                {   
                  title: t('idSent'), 
                  width: '15%',
                  field: 'sentId',
                  cellStyle: {
                      textAlign:'center',
                      padding:'0',
                  },
                  headerStyle:{
                      textAlign:'center',
                      padding:'0'
                  }
                },
                {   
                    title: t('leftContext'), 
                    field: 'left',
                    width: '35%',
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.left,'l',span))} /> ,
                    cellStyle: {
                        textAlign:'right',
                        padding:'0',                    
                    },
                    headerStyle:{
                        textAlign:'center'
                    }
                },
                
                {   
                    title: t('node'), 
                    field: 'node', 
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
                    cellStyle:{
                        textAlign:'center',
                        padding:'0',                          
                    }, 
                    headerStyle:{
                        textAlign:'center'
                    }
                },
        
                {   
                    title: t('rightContext'), 
                    field: 'right', 
                    width: '35%',
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.right,'r',span))} /> ,
                    cellStyle : {
                        textAlign:'left',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center'
                    }
                },
            ]}

            data={ tableData }
            //onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
            components={{
                 Pagination: props => (
                   <TablePagination
                     {...props}
                     rowsPerPageOptions={[10, 25, 50, 100, tableData.length ]}
                   />
                 ),
             }}

            options={{
                selection:true,
                filtering:true,
                search: true,
                sorting: true,
                exportButton: true,
                exportFileName: 'clusters',
                padding: 'dense',
                pageSize:100,
                tableLayout: 'fixed',
                //exportAlldata: true,
                rowStyle: (rowData) => ({
                    backgroundColor: ( rowData.clustId % 2 === 0) ? '#EEE' : '#FFF',
                    height:'40px',
                    maxHeight:'40px'
                })
            }}
        />;
      }
    
      return (
        <>
          <div className="margin-top-2-rem">
                <FormGroup
                    helperText={t('sampleSizeHelp')}
                    label={t('sampleSize')}
                    inline={true}
                    style={formGroupStyle}
                    >
                    <NumericInput
                        buttonPosition={null}
                        defaultValue={this.state.sampleSize.toString()}
                        onValueChange={(newValue) => this.setState({ sampleSize : newValue})}
                    />
                </FormGroup>
                
                <div className='flex'>
                  <Checkbox 
                    inline
                    label={t('ignoreLemma4SomeCats')}
                    checked={this.state.ignoreLemma4SomeCats}  // to control the component
                    onChange={()=>{ this.setState({ignoreLemma4SomeCats:! this.state.ignoreLemma4SomeCats}) }}
                  />
                  <InputGroup 
                    defaultValue={results.params.cat2IgnoreLemma}
                    type='text'
                    onChange={(e) => this.setState({ cat2IgnoreLemma : e.target.value})}
                  />
                </div>                  

                <div className='flex'>
                  <Checkbox
                    inline
                    label={t('ignoreSomeRels')}
                    checked={this.state.ignoreSomeRels}  // to control the component
                    onChange={()=>{ this.setState({ignoreSomeRels:! this.state.ignoreSomeRels}) }}
                  />
                  <InputGroup
                    defaultValue={results.params.rel2Ignore}
                    type='text'
                    onChange={(e) => this.setState({ rel2Ignore : e.target.value})}
                  />
                </div>
                <div className='flex'>
                  <Checkbox
                    inline
                    label={t('ignoreGouverningRels')}
                    checked={this.state.ignoreGouverningRels}  // to control the component
                    onChange={()=>{ this.setState({ignoreGouverningRels:! this.state.ignoreGouverningRels}) }}
                  />
                </div>

                <br/>
                <H4>{t('groupMethod')}</H4>
                <p>{t('methodExplanation')}</p>

                <FormGroup
                    inline={true}
                    style={formGroupStyle}
                    >
                  <RadioGroup 
                    onChange={(e) => this.setState({ method : e.target.value})}
                    selectedValue={this.state.method}
                    inline
                  >
                    <Radio key="group" label={t('group')} value="group" />
                    <Radio key="cah" label={t('cah')} value="cah" />
                  </RadioGroup>
                </FormGroup>

                { this.state.method==="cah" && 
                  <FormGroup
                    helperText={t('cutThresholdHelp')}
                    label={t('cutThreshold')}
                    inline={true}
                    style={formGroupStyle}
                    >
                    <NumericInput
                        // min={0}
                        // max={1}
                        buttonPosition={null}
                        defaultValue={this.state.cutThreshold.toString()}
                        onValueChange={(newValue) => this.setState({ cutThreshold : newValue})}
                    />
                    <Checkbox
                        disabled={false}
                        label={t('useEmbed')}
                        checked={this.state.useEmbed}  // to control the component
                        value={true}
                        onChange={()=>{ this.setState({useEmbed:! this.state.useEmbed}) }}
                    />
                  </FormGroup>
                }
                { this.state.method==="group" && 
                  <FormGroup
                    label={t('minGroupSize')}
                    inline={true}
                    style={formGroupStyle}
                    >
                    <NumericInput
                        buttonPosition={null}
                        defaultValue={this.state.minGroupSize.toString()}
                        onValueChange={(newValue) => this.setState({ minGroupSize : newValue})}
                    />
                  </FormGroup>
                }


                <FormGroup>
                    <Button onClick={this.runContextClustering}>{t('runContextClustering')}</Button>
                </FormGroup>

                { this.state.waitingForCluster && <ProgressBar/> }

                { table && 
                    <p>{t('clickThreeTimesToOpenPopup')}</p>
                }
                {table}

          </div>
        </>
      );
  }
}

ClusterContexts.propTypes = {
  results: PropTypes.object,
  sentId2Concord:PropTypes.object
};

export default withTranslation()(ClusterContexts);
